
function moduleLoader(loader, onload){
    const calls = [];
    let module = null;

    return function(...args){      
        if(module){
            onload.apply(null, [module].concat(args));
            return;
        }

        if(!calls.length){
            calls.push(args);
            loader()
                .then(mod => {                    
                    module = mod;
                    while(calls.length){
                        onload.apply(null, [module].concat(calls.shift()));
                    }   
                });
           return;             
        }
        
       calls.push(args);
    };
}

export const tooltipProxy = moduleLoader(
    () => new Promise(res => import('./tooltip').then(({tooltip}) => res(tooltip))),
    (tooltip, $trigger, options) => tooltip($trigger, options)
);
